export default __webpack_public_path__ + "static/media/666.01b0ac06.png";